import { SearchByKeywords } from '@exam-management/qbank-search-by-keywords';

export default function SearchByKeywordsPage() {
  return <SearchByKeywords />;
}
